<template>
    <div>


        <div class="container-fluid lessons-tabs">
            <div class="container">
                <div class="row justify-content-center lessons-tabs-row">
                    <div class="col-auto" v-for="(video, index) in videos"
                         :key="video.idelement">
                        <base-button
                                @click="currentTabIndex = 0"
                                :class="[{'active': currentTabIndex === 0}]">
                            <span class="dashed-text" v-if="videos.length === 1">{{ $t('lesson') }}</span>
                            <span class="dashed-text" v-else>{{ $t('lesson') }} {{ index + 1}}</span>
                        </base-button>
                    </div>
                    <div class="lesson-timer" v-if="timerText">
                        {{timerText}}
                    </div>
                </div>
            </div>
        </div>


        <div class="container" v-if="currentTabIndex === 0">
            <div class="row no-gutters pt-xl-4">
                <div class="col-xl-3 col-6 tab-test-bird tab-material-bird order-xl-1 order-2">

                </div>
                <div class="col-xl-6 col-12 tab-video-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4">
                    {{exam?exam.exam:''}}
                </div>
                <div class="col-xl-3 col-6 tab-video-points order-xl-3 order-3">
                    <div class="zerno-points">
                        {{points}}
                    </div>
                </div>
                <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mb-xl-0 mb-3">
                    <img v-if="exam" :src="exam.logo" class="single-image" style="max-width: 50%">
                    <div class="tab-video-notice-2 pl-6 pr-6 text-left mt-4 mx-lg-9" v-html="exam?exam.description:''">
                    </div>
                </div>
                <div class="col-12 order-4 order-xl-4 mt-xl-4 mb-xl-5">

                </div>
                <div class="col-12 order-5 mb-xl-6 mb-6">
                    <div class="row justify-content-center text-center">
                        <div class="col-xl-auto col-12">
                            <base-button class="btn-to-next-lesson pl-5 pr-5 mt-xl-0 mt-4" icon="ni ni-curved-next"
                                         size="lg"
                                         @click="toTests">
                                {{ $t('to_tests') }}<!--<i class="fa fa-arrow-right"></i>-->
                            </base-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="container-fluid tab-test" v-if="tests.length > 0 && currentTabIndex === 1">
            <div class="container">
                <div class="row">
                    <div class="col-12">

                        <testpreview
                                v-if="currentTestId && !showAllTestComplete"
                                :idtest="currentTestId"
                                :points="points"
                                :exam="exam"
                                :testsCount="tests.length"
                                :showButtons="true"
                                :key="currentTestId"
                                @correctAnswer="addPoint"
                                @wrongAnswer="wrongAnswer"
                                @testComplete="nextTest"></testpreview>

                        <!-- <lesson-test v-if="!testsPassed && !showAllTestComplete" :tests="tests" :lesson="lesson"
                                     :points="points"
                                     @completed="allTestsPassed"
                                     @correctAnswer="addPoint"></lesson-test>

                        <lesson-match v-if="testsPassed && !showAllTestComplete && matches" :matches="matches"
                                      :lesson="lesson" :points="points"
                                      @completed="allMatchesPassed"
                                      @correctAnswer="addPoint"></lesson-match> -->

                        <div class="row mt-0 mb-0 mx-lg-0 mx-2 justify-content-center" v-if="showAllTestComplete">
                            <div class="col-12 col-lg-6 text-center">

                                <h1 class="mb-5 mt-5">Все тесты выполнены!</h1>
                                <h2 class="mb-3 mt-5">{{ $t('points_achieved') }}: {{points}}
                                    <span v-if="maxPoints > 0"> из {{ maxPoints }}</span>
                                </h2>
                                <h3 v-if="errors && errors.length > 0" class="mb-3 mt-2">
                                    {{ $t('errors_count') }}: {{ errors.length }}
                                </h3>
                                <img :src="examResult.image" class="single-image" style="max-width: 30%">

                            </div>
                            <div class="w-100 d-none d-md-block"></div>
                            <div class="col-12 col-lg-6">
                                <div class="vhtml mb-5 mt-3" v-html="examResult.exam_result"/>
                            </div>
                            <div class="w-100 d-none d-md-block"></div>
                            <div class="col-12 col-lg-6 text-center">
                                <base-button type="primary" icon="ni ni-curved-next" size="lg"
                                             class="mb-3 btn-to-next-lesson"
                                             @click="toNext">
                                    {{ $t('select_course') }}
                                </base-button>
                            </div>

                            <!-- <div class="col-12 mb-5 text-center">
                                <h3 class="mb-3 mt-2">Ты допустил ошибки в следующих вопросах:</h3>
                                <p v-for="(item, i) in errors"
                                   :key="i"
                                   class="vhtml mb-2"
                                >
                                    Тест "{{item.test}}", задание {{$t('№')}}{{item.taskIdx + 1}} - {{item.error}}
                                </p>
                            </div> -->
                            <div class="col-12 col-lg-8 mt-5 mb-9 text-center">
                                <h3 class="mb-3">{{ $t('share_result') }}</h3>
                                <Share
                                        :title="$t('share_text')"
                                        :url="$t('share_url')"
                                        :hashtags="$t('share_tags')"
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>
<style src="@/assets/poliglotiki/main.css">
    .vhtml {
        font-family: "Manrope Light" !important;
        font-size: 16px !important;
        text-align: left;
        line-height: 18px;
        color: #8b8496;
    }

    .vhtml b, .vhtml strong {
        font-family: "Manrope Bold" !important;
    }
</style>
<style scoped>

</style>

<script>
    import {eventBus} from "../main";
    import ProgressApi from "../data/ProgressApi";
    import userApi from "../data/UserApi";
    import api from '@/utils/api'
    import Testpreview from "./Testpreview";
    import {hasRole} from "../data/jwt.service";
    import Share from "./Share";

    export default {
        props: ['id', 'testId'],
        components: {
            Share,
            Testpreview,
        },
        data() {
            return {
                currentTabIndex: 0,
                points: 0,
                maxPoints: 0,

                timerSeconds: 0,
                timer: null,

                exam: null,

                videos: [],
                // materials: [],

                tests: [],
                matches: [],

                // grammars: [],
                // vocabularies: [],

                testsPassed: false,
                matchesPassed: false,
                showAllTestComplete: false,
                examResult: {},
                errors: [],

                progress: {
                    completedLessons: [],
                    completedCourses: [],
                    currentLesson: {
                        id: null,
                        currentTabIndex: 0,
                        currentTestId: null,
                        timerSeconds: 0
                    },
                    points: 0,
                },

                currentTestId: null,
                currentTestNumber: 0,

                isAdmin: false,

            };
        },
        methods: {

            allTestsPassed() {
                this.testsPassed = true
                this.showAllTestComplete = true
                this.completeLesson()

            },

            toTests() {
                this.currentTabIndex = 1
            },

            toNext() {
                this.$router.push('/courses')
            },

            startTimer() {
                this.timer = setInterval(() => {
                    this.timerSeconds++
                }, 1000)
            },

            stopTimer() {
                clearTimeout(this.timer)
            },

            addPoint(cnt) {
                this.points += cnt ? cnt : 1
                //! ProgressApi.addPoints(1)
            },

            wrongAnswer(params) {
                this.errors.push(params)
                console.log(params)
            },

            nextTest() {
                if (this.tests && this.tests.length > this.currentTestNumber + 1) {
                    this.currentTestNumber++;
                    this.currentTestId = this.tests[this.currentTestNumber].idtest
                } else {
                    this.allTestsPassed()
                }
            },

            saveProgress() {
                ProgressApi.saveProgress(
                    this.id,
                    this.currentTabIndex,
                    null,
                    this.timerSeconds)
            },

            completeLesson() {
                this.maxPoints = 0
                for (const i in this.exam.examResults) {
                    const element = this.exam.examResults[i];
                    if (this.maxPoints < element.score_to) this.maxPoints = element.score_to
                    if ((!element.score_from || this.points >= element.score_from) && (!element.score_to || this.points <= element.score_to)) {
                        this.examResult = element
                    }
                }

                api({ method: 'post', url: '/usersexams', data: {
                    idexam: this.id,
                    points: this.points,
                    errors: this.errors.length,
                    errors_data: this.errors,
                    timer_seconds: this.timerSeconds,
                    idexam_result: this.examResult.idexam_result,
                } })
            },

            pad(num, size) {
                var s = num + "";
                while (s.length < size) s = "0" + s;
                return s;
            },

            getColor(lesson) {
                if (this.id == lesson.idlesson) return 'orange'
                if (this.progress.completedLessons.filter(i => i == lesson.idlesson).length > 0) return 'green'
                return 'gray'
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        },

        computed: {
            timerText() {
                const sec = this.timerSeconds % 60
                const min = Math.trunc(this.timerSeconds / 60)
                return this.pad(min, 2) + ':' + this.pad(sec, 2)
            },

        },

        watch: {
            timerSeconds(time) {
                //сохраняем прогрес раз в 10 секунд
                if (time % 10 === 0) {
                    //! this.saveProgress()
                }
            },
            currentTabIndex() {
                //! this.saveProgress()
            }
        },

        async mounted() {
            let resp = await userApi.check()
            this.isAdmin = hasRole('Admin')

            resp = await api({url: '/exams/' + this.id + '?expand=examResults'})
            this.exam = resp.data


            if (this.testId) {
                if (!hasRole('Admin')) this.$router.push('/exam/' + this.id)
                resp = await api({url: '/tests/' + this.testId})
                this.tests = [resp.data]
                this.currentTabIndex = 1
                if (this.tests && this.tests.length > 0) {
                    this.currentTestId = this.tests[this.currentTestNumber].idtest
                }
            } else {
                resp = await api({url: '/tests?filter[idexam]=' + this.id})
                this.tests = resp.data
                if (this.tests && this.tests.length > 0) {
                    this.currentTestId = this.tests[this.currentTestNumber].idtest
                }
            }

            eventBus.$emit('setNavBarTitle', this.exam.exam);
            document.title = this.exam.exam

            /*! TODO: сохранять прогресс
            ProgressApi.fetchProgress()
                .then(progress => {
                    this.progress = progress;
                    this.points = progress.points;
                    if (progress.currentLesson && progress.currentLesson.id === this.id) {
                        this.timerSeconds = progress.currentLesson.timerSeconds;
                        if (progress.currentLesson.currentTabIndex >= 0) {
                            this.currentTabIndex = progress.currentLesson.currentTabIndex;
                        }
                    }
                });
            */
            this.startTimer()
            // ! TODO: сохранять прогресс this.saveProgress()

        },

        destroyed() {
            this.stopTimer()
        },
    };
</script>
<style></style>
